import { render, staticRenderFns } from "./surgery_calendar.vue?vue&type=template&id=1a283443&scoped=true&"
import script from "./surgery_calendar.vue?vue&type=script&lang=js&"
export * from "./surgery_calendar.vue?vue&type=script&lang=js&"
import style0 from "./surgery_calendar.vue?vue&type=style&index=0&id=1a283443&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a283443",
  null
  
)

export default component.exports